import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isExpired } from "../data/AuthenticationApi";

export default function AuthWatcher() {
    const navigate = useNavigate();

    useEffect(() => {
        const interval = setInterval(() => {
            const token = localStorage.getItem("token");
            const savedAt = localStorage.getItem("token_saved_at");
            const expiresIn = localStorage.getItem("token_expires_in");

            // AUTO LOGOUT if token expired or missing
            if (!token || isExpired(savedAt, expiresIn)) {
                localStorage.clear();
                navigate("/login", { replace: true });
            }
        }, 5000); // check every 5 seconds

        return () => clearInterval(interval);
    }, [navigate]);

    return null;
}
